
import React, { useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

const products = [
  {
    name: "Gruner VAV actuator",
    logo: "/lovable-uploads/gruner-logo.png",
    productImage: "/lovable-uploads/gruner-actuator.png",
    description: "VAV actuator with wireless Modbus connectivity.",
    link: "https://www.gruner.de/en/servomotors"
  },
  {
    name: "RYMASKON®",
    logo: "/lovable-uploads/cc9384c0-27f7-470e-8adc-adfacf1a0c2b.png",
    productImage: "/lovable-uploads/e5716f32-310f-49c3-a3f9-bfd8858e05b5.png",
    description: "Room Controller with W-Modbus, for control in residential, hotel and office rooms.",
    link: "https://www.spluss.de/en/products/interface-p23159?_pos=3&_fid=f0b9f15c2&_ss=c&view=a-b-test-hypothese&_pos=3&_fid=f0b9f15c2&_ss=c&vsly-redirected-from=2f16ca44-3d6b-4b48-94fc-aad1a504e6ac-97de0dbf-1faa-4340-8103-1d7c2fce824f&vsly-redirected-event=eyJ0eXBlIjoiVVNFX0NBU0UiLCJ0cyI6MTc3ODg1MjY3MTAwMCwicGF5bG9hZCI6eyJzaWQiOiI3NDAxNDI1NDA4NTczNzk0IiwidXNlciI6eyJhbm9ueW1vdXNfaWQiOiJ6YmJoZXh2Y3B0In0sInVzZV9jYXNlIjoiMmYxNmNhNDQtM2Q2Yi00YjQ4LTk0ZmMtYWFkMWE1MDRlNmFjIiwidXNlX2Nhc2VfdmFyaWFudCI6Ijk3ZGUwZGJmLTFmYWEtNDM0MC04MTAzLTFkN2MyZmNlODI0ZiIsInZlcnNpb24iOjEsImF1ZGllbmNlcyI6InJ8ZCIsImNsaWNrSWQiOiJyZWRpcmVjdCJ9LCJvcHRpb25zIjp7ImdhTmFtZSI6IkZpbHRlcl9mZWF0dXJlc19hbmRfb3BlcmF0aW5nX2luc3RydWN0aW9uc19vbl9zdGFuZGFyZF9mb2xkIiwiZ2FWYXJpYW50IjoiVmFyaWF0aW9uXzEiLCJpc1JlZGlyZWN0Ijp0cnVlfX0%3D"
  },
  {
    name: "CU-LH-MESH",
    logo: "/lovable-uploads/8fca79b3-eff5-48e5-8dc5-5011172806f2.png",
    productImage: "/lovable-uploads/4bb5ff0a-1acb-498e-9371-6bbea8bea1a6.png",
    description: "Zone controller with wireless control through W-Modbus for LumenRadio.",
    link: "https://www.produal.com/en/building-controllers.html?page=1"
  },
  {
    name: "MTSC/SUPER/LR",
    logo: "/lovable-uploads/7e91c0f0-d5c3-4080-8733-ae1433821937.png",
    productImage: "/lovable-uploads/f70eb0e7-df53-4a73-93d6-03474485fe60.png",
    description: "Touchscreen thermostat with W-Modbus - for various HVAC applications.",
    link: "https://meitavtecamerica.com/products/mtsc-super-lr/"
  },
  {
    name: "powerIO®-Box",
    logo: "/lovable-uploads/f77fbf87-109d-47a4-8090-9c29e7b63a3d.png",
    productImage: "/lovable-uploads/37f870d8-4e34-4f9b-b48d-99d4ccbbc947.png",
    description: "A multifunctional automation box with built in wireless Modbus control.",
    link: "https://www.powerio.com/en/products/t1.b100-powerio-box"
  },
  {
    name: "HYGRASGARD®",
    logo: "/lovable-uploads/cc9384c0-27f7-470e-8adc-adfacf1a0c2b.png",
    productImage: "/lovable-uploads/a1774e0d-dd8a-4690-98ce-41fc91fdc978.png",
    description: "On-wall- Humidity and Temperature sensors with W-Modbus.",
    link: "https://www.spluss.de/en/on-wall-humidity-and-temperature-sensors-hygrasgard-aftf-wmodbus-lcd-modbus-1201-12cf-1400-000-p20788/"
  },
  {
    name: "W-Modbus",
    logo: "/lovable-uploads/360b870b-6d26-4213-8713-eaaa1ef722e0.png",
    productImage: "/lovable-uploads/8e09890b-07a4-440e-905f-8a25ca962c6c.png",
    description: "Replace the Modbus RTU cable with reliable wireless mesh. Wall- or DIN rail mounted.",
    link: "https://lumenradio.com/wireless-modbus/w-modbus-devices/"
  }
];

const Products = () => {
  const location = useLocation();

  // Track page view on component mount
  useEffect(() => {
    trackPageView(location.pathname, 'W-Modbus Products');
  }, [location.pathname]);

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#19515f' }}>
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-4 text-center font-magistral font-extrabold tracking-wide">
          W-Modbus Products
        </h1>
        <p className="text-gray-300 text-center mb-4 max-w-2xl mx-auto">
          Manufacturers that offer wireless Modbus products with{' '}
          <a 
            href="https://lumenradio.com/wireless-modbus/w-modbus_oem_modules/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#a6c522] hover:underline"
          >
            W-Modbus
          </a>{' '}
          module from LumenRadio - Patented technologies for unique reliability.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {products.map((product) => (
            <ProductCard key={product.name} {...product} />
          ))}
        </div>

        <div className="flex justify-center">
          <img 
            src="/lovable-uploads/636f788c-9850-49b6-aac1-1eccb1ba981c.png"
            alt="LumenRadio Logo"
            className="h-12 w-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default Products;
